import { render, staticRenderFns } from "./BullRegularizationList.vue?vue&type=template&id=09737658&"
import script from "./BullRegularizationList.vue?vue&type=script&lang=js&"
export * from "./BullRegularizationList.vue?vue&type=script&lang=js&"
import style0 from "./BullRegularizationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports